import React, { useEffect, useRef } from 'react';
import classNames, { Argument } from 'classnames';

type IconFontProps = {
  className?: string;
  fontClass: Argument;
  style?: React.CSSProperties;
  color?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
};

const Icon = ({
  className,
  fontClass,
  style,
  color,
  onClick,
}: IconFontProps): JSX.Element => {
  const svgXML = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const iconfont = require('@/public/iconfont/iconfont.js');

    if (iconfont) {
      const parser = new DOMParser();
      const resXML = parser.parseFromString(iconfont, 'text/xml');
      const zeroXML = resXML.querySelector('#icon-' + fontClass);
      if (zeroXML && svgXML?.current && zeroXML instanceof Element) {
        svgXML.current.innerHTML = zeroXML.innerHTML;
        svgXML.current.setAttribute('id', zeroXML.getAttribute('id') as string);
        svgXML.current.setAttribute(
          'viewBox',
          zeroXML.getAttribute('viewBox') as string
        );
      }
    }
  }, []);

  return (
    <svg
      onClick={onClick}
      fill={color}
      style={style}
      className={classNames([className, `icon ${classNames(fontClass)}`])}
      ref={svgXML}
    />
  );
};

export default Icon;
